exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".main[data-v-69bdb8a0]{padding-top:75px;box-sizing:border-box;min-height:100vh;padding-bottom:70px}.main-full-foot[data-v-69bdb8a0]{padding-bottom:200px!important}", ""]);

// exports
